module.exports = __webpack_public_path__ + "assets/img/2988f58cd421bc904da3a70ac4668a2c.png";